import { useMutation } from '@apollo/client';
import { graphql } from '@app/graphql/types';

export const QUERY = graphql(`
    mutation CheckOnlineOrderPayment($onlineOrderID: ID!) {
        storefront_onlineOrder_waitingPayment_checkPayment(onlineOrderID: $onlineOrderID)
    }
`);

export function useOnlineOrderWaitingPaymentCheck() {
    return useMutation(QUERY, { refetchQueries: ['OnlineOrderDetailPage'] });
} 